@if (working) {
  <div class="loading-container">
    <div class="loading-content">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Loading Slip...</p>
    </div>
  </div>
}
@if (error) {
  <div class="loading-error">
    <p [innerHtml]="error"></p>
    <ion-button color="secondary" class="retry-button" (click)="retry.emit()"> Try again </ion-button>
  </div>
}
